angular.module('impactx.list').component('ixItemExpansion', {
    bindings: {
        row: '<',
        getTemplateUrl: '&',
        getEntryPoint: '&',
        getParams: '&'
    },
    controller: 'ItemExpansionCtrl',
    templateUrl: 'shared/list/templates/item-expansion.tmpl.html'
});